import {createAction, props} from "@ngrx/store";
import {Defense} from "../../models/Defense";

export const UPDATE = '[Defenses] Update';
export const REFRESH = '[Defenses] Refresh';
export const update = createAction(UPDATE, props<{ defenses: Defense[] }>());
export const refresh = createAction(REFRESH);
